import React, { useEffect, useState } from 'react';
import { HiOutlineHeart, HiHeart } from 'react-icons/hi2';
import UserAvatar from '../UserAvatar/UserAvatar';
import { Link } from 'react-router-dom';
import FormatDate from './FormatDate';
import axios from '../../Actions/axios.config';
import UserList from '../Popups/UserList';
import { ROUTES } from '../../constants';

const ReplyCommentCard = ({ comment, handleCommentReply }) => {
  const [like, setLike] = useState(false);
  const [count, setCount] = useState(0);
  const [commentLikes, setCommentLikes] = useState([]);
  const [showCommentLikes, setShowCommentLikes] = useState(false);

  const handleLikeComment = () => {
    setLike(!like);
    setCount(prev => (like ? prev - 1 : prev + 1));
    axios.get(`/comments/like&unlike/${comment._id}`);
  };

  const handleShowCommentLikes = () => {
    axios.get(`/comments/getLikes/${comment._id}`)
      .then((response) => {
        setCommentLikes(response.data.Likedby.likes);
        setShowCommentLikes(true);
      })
      .catch((error) => console.log(error));
  };

  useEffect(() => {
    axios.get(`/comments/getLikes/${comment._id}`)
      .then((response) => {
        setLike(response.data.userLike);
        setCount(response.data.Likedby.likes.length);
      })
      .catch((error) => console.log(error));
  }, [comment._id]);

  return (
    <div className="group animate-in fade-in slide-in-from-left-1 duration-300">
      <div className="flex gap-2">
        {/* Smaller Avatar for Replies */}
        <Link 
          to={ROUTES.userProfile(comment.user)} 
          className="flex-shrink-0 mt-1 transition-transform active:scale-90"
        >
          <UserAvatar src={comment.userProfileImage} name={comment.userName} size={28} className="ring-1 ring-slate-100 group-hover:ring-blue-300 transition-colors" />
        </Link>

        <div className="flex-grow">
          {/* Reply Bubble */}
          <div className="bg-slate-50 border border-slate-100 p-3 rounded-2xl rounded-tl-none group-hover:bg-white group-hover:shadow-sm transition-all">
            <div className="flex justify-between items-center mb-0.5">
              <Link 
                to={ROUTES.userProfile(comment.user)} 
                className="font-bold text-slate-900 text-xs hover:text-blue-600 transition-colors"
              >
                {comment.userName}
              </Link>
              <span className="text-[9px] font-bold text-slate-400 uppercase tracking-tighter">
                {FormatDate(comment.createdAt)}
              </span>
            </div>
            
            <p className="text-slate-600 text-sm leading-relaxed">
              {comment.text}
            </p>
          </div>

          {/* Action Bar */}
          <div className="flex items-center gap-4 mt-1.5 ml-1">
            <button 
              onClick={handleLikeComment}
              className={`flex items-center gap-1 text-[11px] font-bold transition-colors ${
                like ? 'text-red-500' : 'text-slate-400 hover:text-slate-600'
              }`}
            >
              {like ? <HiHeart size={14} /> : <HiOutlineHeart size={14} />}
              <span>{count > 0 ? count : 'Like'}</span>
            </button>

            {count > 0 && (
              <button 
                onClick={handleShowCommentLikes}
                className="text-[9px] font-black text-slate-300 uppercase tracking-widest hover:text-slate-500 transition-colors"
              >
                Likers
              </button>
            )}
          </div>
        </div>
      </div>

      {showCommentLikes && (
        <UserList 
          likers={commentLikes} 
          onClose={() => setShowCommentLikes(false)}
        />
      )}
    </div>
  );
};

export default ReplyCommentCard;